// DS7.4.1
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { Url, URLS } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CoreIcon from '@wix/da-ds/pkg/Icons/24x24/Core';
import GiftIcon from '@wix/da-ds/pkg/Icons/24x24/Gift';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import Banner from '@wix/da-ds/pkg/Banner';
import { formatDate } from '../Timestamp/functions';
import s from './SaleBanner.scss';
var dateFormat = {
    month: 'long',
    day: 'numeric',
};
var SaleBanner = function (_a) {
    var discountValuePercent = _a.discountValuePercent, endDate = _a.endDate, isNarrow = _a.isNarrow, giftRecipient = _a.giftRecipient, referralType = _a.referralType, className = _a.className;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    // !! because MobileContext is returning an unknown!?
    var isMobile = !!useContext(MobileContext);
    var isGift = !!giftRecipient;
    var localeKeys = getLocaleKeys(isGift, isMobile, isNarrow);
    var isShowingPreamble = !isNarrow && !isMobile;
    var ButtonComponent = isNarrow ? TextButton : GhostButton;
    var href = isGift && giftRecipient
        ? Url.giveCoreMembership(giftRecipient)
        : URLS.CORE_MEMBERSHIP;
    return (React.createElement(Banner, { className: classnames(s['root'], isNarrow ? s['narrow'] : s['wide'], className), message: React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
            React.createElement("span", { className: s['message'] },
                isShowingPreamble && (React.createElement("span", { className: s['preamble'] }, t(localeKeys.preamble, {
                    username: giftRecipient,
                }))),
                isGift && React.createElement(GiftIcon, { className: s['gift-icon'] }),
                !isGift && React.createElement(CoreIcon, { className: s['core-icon'] }),
                React.createElement("span", { className: s['sale'] }, t(localeKeys.sale, {
                    sale: discountValuePercent,
                    date: endDate
                        ? formatDate(endDate, dateFormat, i18n.language)
                        : undefined,
                })))), customCtaButton: React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
            React.createElement(ButtonComponent, { size: "small", variant: "main", className: s['button'], href: href, biData: {
                    evid: BiEventType.BUY_CORE_BUTTON,
                    referral_info: referralType,
                } }, t(localeKeys.button))) }));
};
SaleBanner.displayName = 'SaleBanner';
export default SaleBanner;
function getLocaleKeys(isGift, isMobile, isNarrow) {
    // saleBanner.mobile.preamble
    // saleBanner.mobile.sale
    // saleBanner.mobile.button
    // saleBanner.narrow.preamble
    // saleBanner.narrow.sale
    // saleBanner.narrow.button
    // saleBanner.preamble
    // saleBanner.sale
    // saleBanner.button
    // saleBanner.gift.mobile.preamble
    // saleBanner.gift.mobile.sale
    // saleBanner.gift.mobile.button
    // saleBanner.gift.narrow.button
    // saleBanner.gift.preamble
    // saleBanner.gift.sale
    // saleBanner.gift.button
    var keyBase = 'saleBanner';
    if (isGift) {
        keyBase += '.gift';
    }
    if (isMobile) {
        keyBase += '.mobile';
    }
    else if (isNarrow) {
        keyBase += '.narrow';
    }
    return {
        preamble: keyBase + ".preamble",
        sale: keyBase + ".sale",
        button: keyBase + ".button",
    };
}
//# sourceMappingURL=SaleBanner.js.map